// extracted by mini-css-extract-plugin
module.exports = {"cyber_review":"CyberReview_cyber_review__E0eW8","cyber_review_text":"CyberReview_cyber_review_text__YhfQl"};